import * as Yup from 'yup';
import { balanceTransactionsTypesTranslations } from 'constants/balanceTransactionTypes';

export const balanceTransactionSchema = Yup.object().shape({
  type: Yup.string().oneOf(Object.keys(balanceTransactionsTypesTranslations)).required('Тип обовʼязковий'),
  description: Yup.string().optional(),
  amount: Yup.number()
    .typeError('Сума повинна бути числом')
    .positive('Сума повинна бути додатньою')
    .required('Сума обовʼязкова'),
});
